import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getAccountInfoService } from '@musinsa/services-curator';

export const accountInfoFactory = createQueryKeys('accountInfo', {
  detail: {
    queryKey: null,
    queryFn: () => getAccountInfoService(),
  },
});
